import { APIClient } from "api/api_helper";
import { GetUserData, CurrentUser, formatDateSplit } from "common/service/CommonService";
import { VOLUNTEER_TRANSFER_API } from "api/url_helper";

const api = new APIClient();

export const transferVolunteerApiService = {
  // INSERT METHOD
  insertData: (payload: any) => {
    const user = GetUserData() as CurrentUser;
    const formData = new FormData();

    // Map properties to match requested API payload
    const payload_data: Record<string, any> = {
      volunteerid: Number(payload.volunteerid),
      fromstudyid: Number(payload.studyid), // current study is fromstudyid
      tostudyid: Number(payload.targetstudyid),
      transfertype: Number(payload.transfertype),
      transferreason: Number(payload.transferreason),
      transferdate: formatDateSplit(payload.transferdate),
      isscreeningrequired: payload.rescreeningrequired === "Yes" ? true : false,
      remarks: payload.remarks || null,
      createdby: user?.userid,
    };

    // 1. Append form fields
    Object.entries(payload_data).forEach(([key, value]) => {
      if (value !== null) {
        formData.append(key, value as any);
      }
    });

    // 2. Append files
    if (Array.isArray(payload.attachments)) {
      payload.attachments.forEach((file: File) => {
        formData.append("files", file);
      });
    }

    return api.create(VOLUNTEER_TRANSFER_API.VOLUNTEER_TRANSFER_API + "Insert", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  // SELECT ALL METHOD
  getSelectAllData: (params: {
    searchText: string;
    currentPage: number;
    pageSize: number;
    studyid: number;
    isOutgoingOnly:boolean;
  }) => {
    const { searchText, currentPage, pageSize, studyid, isOutgoingOnly } = params;
    const payload = {
      searchtext: searchText,
      currentpage: currentPage,
      pagesize: pageSize,
      studyid: studyid,
      isoutgoingonly: isOutgoingOnly,
    };
    return api.create(VOLUNTEER_TRANSFER_API.VOLUNTEER_TRANSFER_API + "SelectAll", payload);
  },

  // SELECT METHOD
  getSelectData: (volunteertransferid: number) => {
    const payload = {
      volunteertransferid: volunteertransferid,
    };
    return api.create(VOLUNTEER_TRANSFER_API.VOLUNTEER_TRANSFER_API + "Select", payload);
  },

  getStudyDropdownData: (data: {studyid: number; volunteerid:number;}) => {
    const payload = {
      studyid : data.studyid,
      volunteerid : data.volunteerid,
    };
    return api.create(VOLUNTEER_TRANSFER_API.VOLUNTEER_TRANSFER_API + "Dropdown", payload);
  },

  // UPDATE METHOD
  updateData: (payload: any) => {
    const user = GetUserData() as CurrentUser;
    const formData = new FormData();

    const payload_data: Record<string, any> = {
      volunteertransferid: Number(payload.volunteertransferid), 
      volunteerid: Number(payload.volunteerid),
      fromstudyid: Number(payload.studyid),
      tostudyid: Number(payload.targetstudyid),
      transfertype: Number(payload.transfertype),
      transferreason: Number(payload.transferreason),
      transferdate: formatDateSplit(payload.transferdate),
      isscreeningrequired: payload.rescreeningrequired === "Yes" ? true : false,
      remarks: payload.remarks || null,
      updatereason: payload.updatereason,
      updatedby: user?.userid,
    };

    // 1. Append form fields
    Object.entries(payload_data).forEach(([key, value]) => {
      if (value !== null) {
        formData.append(key, value as any);
      }
    });

    // 2. Append files
    if (Array.isArray(payload.attachments)) {
      payload.attachments.forEach((file: File) => {
        formData.append("files", file);
      });
    }

    // Handle deleted attachments array if any
    if (payload.deletedAttachmentIds && Array.isArray(payload.deletedAttachmentIds)) {
      formData.append("deletedAttachmentIds", JSON.stringify(payload.deletedAttachmentIds));
    }

    return api.create(VOLUNTEER_TRANSFER_API.VOLUNTEER_TRANSFER_API + "Update", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  // VERIFY METHOD
  verifyData: (payload: any) => {
    return api.create(VOLUNTEER_TRANSFER_API.VOLUNTEER_TRANSFER_API + "Verify", payload);
  },

  // DELETE METHOD
  deleteData: (payload: any) => {
    const user = GetUserData() as CurrentUser;
    const payload_data = {
      volunteertransferid: Number(payload.volunteertransferid),
      updatedby: user?.userid,
      updatereason: payload.updatereason,
    };
    return api.create(VOLUNTEER_TRANSFER_API.VOLUNTEER_TRANSFER_API + "Delete", payload_data);
  },
};
